import { Box, Divider, Flex, Image } from "@chakra-ui/react";
import styles from "./About.module.scss";
import gameIcon from "../../../assets/aimon/game.png";

export default function About() {
  return (
    <Flex className={styles.container} id="about">
      <img src={gameIcon} alt="logo" className={styles.gameIcon} />

      <Flex className={styles.content}>
        <Box className={styles.contentTitle}>About</Box>
        <Box className={styles.contentText}>
          AIMon pioneers the fusion of artificial intelligence and blockchain
          technology to create a dynamic metaverse of evolving creatures.
          Inspired by iconic franchises like Pokémon and Digimon, AIMon offers a
          unique gaming experience where each Vimon is continuously generated
          and balanced by advanced AI algorithms, ensuring endless adventures
          and true ownership through blockchain integration
        </Box>
      </Flex>
    </Flex>
  );
}
